import { Schema, arrayOf } from 'normalizr';

export const subscriptionSchema = new Schema('subscription', { idAttribute: 'subscriptionId' });
export const subscriptionsSchema = arrayOf(subscriptionSchema);
